import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, } from 'rxjs';
import {  catchError } from 'rxjs/operators';
import { urls } from '../../utils/url-utils';
import { errorHandl } from '../../utils/network-utils';
import * as moment from 'moment-timezone';
import { PlacementAuthService } from '../placement-auth-service/placement-auth.service';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public KEY_TOKEN: 'token';
  private user;
  private mfaSubject = new BehaviorSubject<string | null>(
      JSON.parse(localStorage.getItem('mfaToken')) || null
  );

  mfa$ = this.mfaSubject.asObservable();

  constructor(
    private http: HttpClient,
    private placementAuthService: PlacementAuthService
  ) {
  }


  staffComponentRoles = {
    // corporateapp: 'Full Access',
    // accountant: 'Biller',
    // credential: 'Credentialer',
    // mdispatcher: 'Manager (RM,SM,ASM)',
    // dispatcher: 'Dispatcher',
    // mcallcenter: 'Call Center Manager',
    // rcallcenter: 'Call Taker'
    ccooperate: 'Full Access',
    // crcallcenter: 'Call Center Representative',
    cdispatcher: 'Transportation Coordinator'
  }

  accountStatus = {
    active: 'Active',
    inactive: 'InActive',
  }

  fleetAccountStatus = {
    active: 'Active',
    inactive: 'InActive',
  }

  driverComponentProfileRoles = {
    driver: 'Driver',
    dispatcher: 'Dispatcher'
  }



  login(payload): Observable<any> {

    return this.http.post<any>(urls.BASE_URL+ urls.SIGNIN_URL, payload )
      .pipe(
        catchError(errorHandl)
      );
  }
  
    sendMfaCode(isReSend, payload): Observable<any> {
    const url = isReSend? urls.Re_SEND_MFA_URL : urls.SEND_MFA_URL;
    return this.http.post<any>(urls.BASE_URL + url, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  verifyMfaCode(payload): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.VERIFY_MFA_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  VerifyToken(): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.PROFILE_URL)
      .pipe(
        catchError(errorHandl)
      );
  }

  forgetPasswordRequest(payload) {
    return this.http.post<any>(urls.BASE_URL + urls.FORGOT_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  // saving token
  setToken(data: any): void {
    try {
      localStorage.setItem('token', JSON.stringify(data));
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  removeToken(): void {
    try {
      localStorage.removeItem('token');
      this.placementAuthService.clearTokensFromStorage();
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  getToken(key: string) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      console.error('Error getting data from localStorage', e);
      return null;
    }
  }

  setMFA(data: any): void {
    try {
      localStorage.setItem('mfaToken', JSON.stringify(data));
      this.mfaSubject.next(data);
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  removeMFA(): void {
    try {
      localStorage.removeItem('mfaToken');
      this.mfaSubject.next(null);
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }
  
  getUserData() {
    return this.user;
  }

  CheckLoginValidation(user, isAuthLoggedIn: boolean) {
    if (user == null) {
      this.user = null;
    } else {
      this.user = user;
      moment.tz.setDefault(user.timeZone);

    }
  }

  getGoogleKeys(): Observable<any> {
    return this.http.get<any>("https://gckeys.nemtplatform.com/get-server-key")
      .pipe(
        catchError(errorHandl)
      );
  }

  verifyResetToken(token: string, role: string) {
    return this.http.get(`${urls.BASE_URL + urls.RESET_URL}/${token}/${role}`);
  }
  resetPassword(token: string, role: string, payload: any) {
    return this.http.post(`${urls.BASE_URL + urls.RESET_URL}/${token}/${role}`, payload);
  }

  }







